import { Environment } from '../const/Environment'
import { getEnvironment } from './misc'

export const isProduction = () => {
  const env = getEnvironment()
  return (
    env === Environment.production ||
    env === Environment['production.us-east-1']
  )
}
